import GET_ARTICLES from "../class/getArticles";

const [ w, d, mq ] = [window, document, window.matchMedia("(min-width:900px)") ];

const domReady = TPL => {
  new BLOCKS;
};

class BLOCKS {
  constructor() {
    this.mainvisual();
    this.stock();
    this.news();
  }

  mainvisual () {
    let Mv = document.querySelector('.mainvisual');
    w.addEventListener('load', function() {
      Mv.classList.add('loaded');
    });

    // mainvisual news_ticker
    const news_ticker = new GET_ARTICLES('.mainvisual__news-article[data-plugin="getArticles"]');
    news_ticker.makeItem = (item,content) => `
      <a class="mainvisual__news-link" href="${item.href}">
        <p class="date">${item.date}</p>
        <p class="cat">${item.category.name}</p>
        <p class="title"><span>${item.title}</span></p>
      </a>`
    news_ticker.render();

    // 上方向スクロールでのヘッダー上の透け防止
    if(mq.matches){
      w.addEventListener('scroll', function() {
        const header = document.querySelector('.rwd002-header');
        if (w.scrollY === 0) {
          header.classList.add('stop');
        } else {
          header.classList.remove('stop');
        }
      });
    }
  }

  stock () {
    const getArticle = new GET_ARTICLES('.block-stock__machinery-list');
    getArticle.makeItem = (item, content) => {
      let categoryClass = '';
      switch (item.category.name) {
        case '在庫有り':
          categoryClass = 'is-available';
          break;
        case '商談中':
          categoryClass = 'is-keep';
          break;
        case '売却済':
          categoryClass = 'is-unavailable';
          break;
        default:
          categoryClass = '';
      }
    
      return `
        <li class="block-stock__machinery-item rwd002-stock__item">
          <a class="block-stock__machinery-link rwd002-stock__link${(item.is_new) ? ' is-new' : ''}" href="${item.href}">
            <figure class="thumb">
              <img src="${item.thumb}" alt="${item.title}">
              <figcaption class="item_status ${categoryClass}">${item.category.name}</figcaption>
            </figure>
            <p class="ttl">${item.title}</p>
          </a>
        </li>`;
    };
    // getArticle.makeItem = (item) => console.log(item);
    getArticle.render();
  
    // カテゴリー
    const getContentData = Promise.all([
      getArticle.fetchArticles({
        content: 'machinery',
        post_per_page: 1,
        category_in: 0
      }),
      getArticle.fetchCategories('news'),
    ]).then( res => Promise.all(res.map(r=>r.json())) );
  
    let categoryContainer = d.querySelector('.block-news .tag_list[data-plugin="getCategories"]');
    getContentData.then( ([noCatArticles,cats]) => {
      categoryContainer.innerHTML = '';
      if( noCatArticles && noCatArticles.length > 0){
        cats.push({id:'0',name:'その他',href:`/news/?mode=list&cat=0`});
      }
      cats.forEach( item => {
        let itemHtml = `<li><a href="${item.href}">${item.name}</a></li>`;
        categoryContainer.insertAdjacentHTML('beforeend', itemHtml);
      });
    });
  }

  news () {
    const getArticle = new GET_ARTICLES('.block-topics__list');
    getArticle.makeItem = (item,content) => `
    <li class="block-topics__item">
      <a class="block-topics__link${(item.is_new)? ' is-new"': ''}" href="${item.href}">
        <p class="date">${item.date}</p>
        <p class="cat">${item.category.name}</p>
        <p class="ttl">${item.title}</p>
        <svg class="icon icon_arrow">
          <use href="/assets/svg/sprite.symbol.svg#icon_arrow"></use>
        </svg>
      </a>
    </li>`;
    // getArticle.makeItem = (item) => console.log(item);
    getArticle.render();

    // カテゴリー
    const getContentData = Promise.all([
      getArticle.fetchArticles({
        content: 'news',
        post_per_page: 1,
        category_in: 0
      }),
      getArticle.fetchCategories('news'),
    ]).then( res => Promise.all(res.map(r=>r.json())) );

    let categoryContainer = d.querySelector('.block-news .tag_list[data-plugin="getCategories"]');
    getContentData.then( ([noCatArticles,cats]) => {
      categoryContainer.innerHTML = '';
      if( noCatArticles && noCatArticles.length > 0){
        cats.push({id:'0',name:'その他',href:`/news/?mode=list&cat=0`});
      }
      cats.forEach( item => {
        let itemHtml = `<li><a href="${item.href}">${item.name}</a></li>`;
        categoryContainer.insertAdjacentHTML('beforeend', itemHtml);
      });
    });
  }
}

const jqInit = () => false;

export default function HOME () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  
  $(() => jqInit());
}